export const getDefaultState = () => {
  const defaultUnit = {
    vin: null,
    unitTypeId: null,
    unitStatusId: null,
    mileage: null,
    engineHours: null,
    dateInService: null,
    leaseExpirationDate: null,
    purchaseDate: null,
    registrationExpirationDate: null,
    powerSource: {},
    transmission: {},
    attributeMap: null,
    attributes: [],
    pairedUnits: [],
    showInOpsForecast: null,
    isUnitAtVehicareBranch: null
  };

  return {
    unit: {
      ...defaultUnit
    },
    dbUnit: {
      ...defaultUnit
    },
    unitOperationsForecast: [],
    unitServiceOrderHistory: [],
    unitStandardOperationHistories: [],
    unitDeferredJobs: [],
    unitStandardOperation: {},
    unitStandardOperations: [],
    unitInspections: [],
    unitDvirDefects: [],
    dbUnitDvirDefects: [],
    unitServiceOrdersAsideShow: false,
    loading: [],
    customerUnits: []
  };
};

export default {
  ...getDefaultState()
};
